import { render, staticRenderFns } from "./StatusProgress.vue?vue&type=template&id=6b1a54f3&scoped=true"
import script from "./StatusProgress.vue?vue&type=script&lang=js"
export * from "./StatusProgress.vue?vue&type=script&lang=js"
import style0 from "./StatusProgress.vue?vue&type=style&index=0&id=6b1a54f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a54f3",
  null
  
)

export default component.exports